import { configureStore, ConfigureStoreOptions } from '@reduxjs/toolkit';

import thunk from 'redux-thunk';

import websocketMiddleware from 'websocketMiddleware';

import { webSocketReducer } from 'state/websockets';
import { authReducer } from 'state/auth';
import { organisationsReducer } from 'state/organisations';
import { groundstationsReducer } from 'state/groundstations';
import { antennasReducer } from 'state/antennas';
import { satellitesReducer } from 'state/satellites';
import { schedulesReducer } from 'state/schedules';
import { alertsReducer } from 'state/alerts';
import { switchesReducer } from 'state/switches';
import { sensorsReducer } from 'state/sensors';

export const store = configureStore({
    reducer: {
        auth: authReducer,
        websocket: webSocketReducer,
        organisations: organisationsReducer,
        groundstations: groundstationsReducer,
        antennas: antennasReducer,
        schedules: schedulesReducer,
        alerts: alertsReducer,
        satellites: satellitesReducer,
        switches: switchesReducer,
        sensors: sensorsReducer,
    },
    middleware: [thunk, websocketMiddleware],
});

export type RootState = ReturnType<typeof store.getState>;

export type AppDispatch = typeof store.dispatch;

/**
 * Intended to be used by tests
 * @param state The inital state of the Redux App
 * @returns A new redux store, with an initial state
 */
export const makeStoreWithState = (
    state?: ConfigureStoreOptions<RootState>['preloadedState'],
) =>
    configureStore({
        reducer: {
            auth: authReducer,
            websocket: webSocketReducer,
            groundstations: groundstationsReducer,
            antennas: antennasReducer,
            schedules: schedulesReducer,
            alerts: alertsReducer,
        },
        middleware: [thunk, websocketMiddleware],
        preloadedState: state,
    });

export default store;
